/**
 * Awalan path bila aplikasi dipasang di sub-path (mis. "/kurasi-harga" di belakang reverse proxy). Kosong di root.
 * NEXT_PUBLIC_ agar ikut tertanam di kode browser. Next.js menambahkan awalan ini sendiri untuk <Link>, redirect(),
 * dan router; yang harus dibungkus manual hanya <a href>, <img>/Image, <iframe>, fetch, dan XHR ke path internal.
 */
export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

export const withBase = (path: string) => `${BASE_PATH}${path}`;
